import React from "react";

export const AudioAvatarIcon = React.memo(({size = 250}:{size?: number}) => {
    return (
        <svg style={{minWidth: size}} width={size} height={size} viewBox="0 0 350 350" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="350" height="350" rx="175" fill="#D9D9D9"/>
            <circle cx="117" cy="166.761" r="8" fill="#A0A0A0"/>
            <circle cx="233" cy="166.761" r="8" fill="#A0A0A0"/>
            <path d="M151.1 182.761C170.772 194.129 181.318 194 198.901 182.761" stroke="#A0A0A0" strokeWidth="5" strokeLinecap="round"/>
        </svg>
    )
});